export const ENDPOINTS = {
  ENV: `{server}/api/v1/env`,
  SOURCES: `{server}/api/v1/sources`,
  QUEUES: `{server}/api/v2/queues`,
  STATISTICS: `{server}/api/v1/statistics`,
  CONFIGURATION: {
    SAVE: `{server}/api/v2/configuration`,
    GET: `{server}/api/v2/configuration`,
    GET_BY_INPUT: `{server}/api/v2/configuration/{input}`,
    GET_BY_ID: `{server}/api/v2/configuration/{input}/{configurationId}`,
    DELETE: `{server}/api/v2/configuration`,
    ACTIVATE: `{server}/api/v2/activate/{configurationId}`
  },
  AUTH: `{server}/api/v1/auth`,
  AUDIT: `{server_audit}/api/v1/audit`,
  REPORT: '{server_report}/api/v1/report'
}

export const CONSTANTS_KEY = {
  TOKEN: 'ms:rb:access_token'
}

export const ROUTES = {
  LOGIN: 'login',
  CONFIG: 'config-balance',
  DASHBOARD: 'dashboard',
  AUDIT: 'audit',
  REPORTS: 'reports'
}

export const WEEK = {
  1: 'Lunes',
  MONDAY: {
    LONG: 'Lunes',
    INITIAL: 'L'
  },
  2: 'Martes',
  TUESDAY: {
    LONG: 'Martes',
    INITIAL: 'M'
  },
  3: 'Miercoles',
  WEDNESDAY: {
    LONG: 'Miércoles',
    INITIAL: 'X'
  },
  4: 'Jueves',
  THURSDAY: {
    LONG: 'Jueves',
    INITIAL: 'J'
  },
  5: 'Viernes',
  FRIDAY: {
    LONG: 'Viernes',
    INITIAL: 'V'
  },
  6: 'Sabado',
  SATURDAY: {
    LONG: 'Sábado',
    INITIAL: 'S'
  },
  7: 'Domingo',
  SUNDAY: {
    LONG: 'Domingo',
    INITIAL: 'D'
  },
}

export function getRandomColor(i?: number) {
  const colors: string[] = [
    'paleturquoise',
    'lavender',
    'antiquewhite',
    'lavenderblush',
    'aquamarine',
    'lightblue',
    'beige',
    'bisque',
    'cornsilk',
    'khaki',
  ]

  if (i) {
    return colors[i]
  } else {
    var color = colors[Math.floor(Math.random() * colors.length)];
    return color
  }
}

export const DATE_FORMAT = {
  HOURS: 'HH',
  MINUTES:'mm',
  SHORT: 'dd/MM/yyyy',
  MEDIUM: 'dd/MM/yyyy HH:mm', 
  LARGE: 'dd/MM/yyyy HH:mm:ss',
  SHORT_MIDDLE_DASH: 'YYYY-MM-DD',
  LARGE_MIDDLE_DASH: 'YYYY-MM-DD HH:mm:ss',
  ISO: 'yyyy-MM-DDTHH:mm',
}